<template>
	<v-row>
		<v-img id="clover-1" :src="require('assets/static/img/extras/lucklotto/clover-green.webp')" />
		<v-img id="clover-2" :src="require('assets/static/img/extras/lucklotto/clover-orange.png')" />
		<v-img id="clover-3" :src="require('assets/static/img/extras/lucklotto/clover-yellow.png')" />
		<v-img id="dollar-1" :src="require('assets/static/img/extras/lucklotto/dollar-yellow.png')" />
		<v-img id="dollar-2" :src="require('assets/static/img/extras/lucklotto/dollar-green.png')" />
		<v-img id="dollar-3" :src="require('assets/static/img/extras/lucklotto/dollar-green.png')" />
		<v-img id="dollar-4" :src="require('assets/static/img/extras/lucklotto/dollar-green.png')" />
		<v-fade-transition mode="out-in">
			<slots
				v-if="mode === modes.roulette"
				:result="result"
				@finish="handleResultsDone"
			>
				<template v-slot:logo>
					<v-img :src="require('assets/static/img/logo/lucklotto.png')">
					</v-img>
					 </template>
			</slots>
			<winning-numbers
				v-else-if="mode === modes.winningNumbers"
				:result="result"
			></winning-numbers>
		</v-fade-transition>
	</v-row>
</template>

<script>
import WinningNumbers from './WinningNumbers.vue';
import { Howl } from 'howler';
import song from 'assets/static/sounds/piano_instrumental.mp3';
import Slots from './Slots.vue';

const modes = {
	roulette: 1,
	winningNumbers: 2
};

export default {
	name: 'Roulette',
	props: {
		result: {
			type: Object,
			required: true
		}
	},
	created() {
		this.sound.play();
	},
	destroyed() {
		this.sound.stop();
	},
	components: {
		WinningNumbers,
		Slots
	},
	data() {
		return {
			modes,
			mode: modes.roulette,
			sound: new Howl({
				src: song,
				duration: 4,
				autoplay: false,
				volume: 0.3,
				loop: true
			})
		};
	},
	methods: {
		handleResultsDone() {
			this.mode = modes.winningNumbers;

			setTimeout(() => {
				this.$root.$emit('sortition-time-done');
			}, 15000);
		}
	}
};
</script>

<style lang="scss" scoped>
.floating-image {
	z-index: 0;
	opacity: 0.4;
}

#clover-1 {
	width: 150px;
	position: absolute;
	left: 20vw;
	top: 8vh;
	transform: rotate(-30deg);
	@extend .floating-image;
}

#clover-2 {
	width: 100px;
	position: absolute;
	right: 80px;
	bottom: 150px;
	@extend .floating-image;
}

#clover-3 {
	width: 100px;
	position: absolute;
	left: 40px;
	top: 50vh;
	@extend .floating-image;
}

#dollar-1 {
	width: 150px;
	position: absolute;
	right: 10vw;
	top: 10vh;
	transform: rotate(30deg);
	@extend .floating-image;
}

#dollar-2 {
	width: 100px;
	position: absolute;
	left: 80px;
	top: 20vh;
	transform: rotate(-30deg);
	@extend .floating-image;
}

#dollar-3 {
	width: 100px;
	position: absolute;
	right: 5vw;
	bottom: 40vh;
	transform: rotate(-30deg);
	@extend .floating-image;
}

#dollar-4 {
	width: 100px;
	position: absolute;
	left: 5vw;
	bottom: 20vh;
	transform: rotate(-30deg);
	@extend .floating-image;
}
</style>
